<lib-image-field label="Digital Wallet" [fontImage]="digitalWalletFontImage">
  @if (!digitalWalletFontImage && digitalWalletImageFile) {
    <img [src]="digitalWalletImageFile" height="32px" class="digital-wallet-image-field-img" />
  }
</lib-image-field>
